/** A failed network check cannot establish that an account has signed out. */
export function sessionNeedsSignIn(input: {
  hasUser: boolean;
  pending: boolean;
  online: boolean;
  errorStatus: number | null;
}): boolean {
  if (input.hasUser || input.pending || !input.online) return false;
  return (
    input.errorStatus === null ||
    input.errorStatus === 401 ||
    input.errorStatus === 403
  );
}
